import React from 'react';
import { WebsiteLayout } from '../components/common/layout';
import { Contact } from '../components/screens';

function PageWithLayout({ logout, user }) {
  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <Contact />
    </WebsiteLayout>
  );
}

export default PageWithLayout;
